<template>
  <div class="search-form">
    <ion-searchbar
      v-model="searchModel"
      class="search-form__control"
      show-clear-button="never"
      :placeholder="placeholder"
      ref="searchBarRef"
      :disabled="disabled"
    >
      <ion-icon v-if="(isDesktop && searchModel) || !isDesktop" class="btn clear-btn" src="assets/icon/cross-mark.svg" @click="clear"/>
      <ion-icon v-if="isDesktop && !searchModel" class="btn search-btn" src="assets/icon/search.svg"/>
    </ion-searchbar>
  </div>
</template>

<script setup lang="ts">
import { IonSearchbar, IonIcon } from '@ionic/vue';
import { onMounted, ref } from 'vue';
import { useVModel } from '@vueuse/core';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import StorageService from "@/helpers/storageService";
import { EventNamesEnum } from '@/const/events';

const { isDesktop } = useBreakpoint();

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    placeholder?: string;
    disabled?: boolean;
  }>(),
  {
    placeholder: '',
    disabled: false,
  }
);

const clear = () => {
  let filters = StorageService.getItem('filters', 'ss');
  if(filters?.search) {
    filters = {...filters, search: ''};
    StorageService.setItem('filters', filters, 'ss')
  }
  searchModel.value = '';
  emits(EventNamesEnum.OnClear);
};

const emits = defineEmits<{
  (e: EventNamesEnum.OnUpdateModelValue, value: string): void;
  (e: EventNamesEnum.OnClear): void;
}>();

const searchModel = useVModel(props, 'modelValue', emits);

const searchBarRef = ref<typeof IonSearchbar | null>(null);

onMounted(() => {
  setTimeout(() => searchBarRef.value?.$el.setFocus());
  searchModel.value = props.modelValue
});
</script>

<style lang="scss" scoped>
.search-form {
  width: 326px;
  min-height: 27px;
  display: flex;
  align-items: center;

  &__control {
    padding: 0;
    width: 100%;
    z-index: 15;
    transition: right 0.35s ease;
    --border-radius: 8px;
    --color: var(--ion-color-dark);
    --placeholder-opacity: 1;
    --background: var(--ion-color-white);
    --icon-color: var(--ion-color-primary);
    --placeholder-font-weight: 300;
    --placeholder-color: var(--ion-color-dark);
    --box-shadow: inset 0 0 0 1px var(--ion-color-primary);
    position: relative;

    .btn {
      position: absolute;
      right: 6px;
      top: 6px;
      font-size: 28px;
      z-index: 1;

      @media only screen and (min-width: 1024px) {
        top: 10px;
        right: 10px;
      }
    }

    .clear-btn {
      color: var(--ion-color-primary);
      width: 16px;
      height: 16px;
      @media only screen and (min-width: 1024px) {
        height: 25px;
        width: 25px;
      }
    }

    .search-btn {
      color: var(--ion-color-grey);
    }
  }
}
</style>

<style lang="scss">
.searchbar-search-icon.sc-ion-searchbar-md {
  left: auto;
  right: 10px;
  top: 3px;
  display: none !important;

}
.searchbar-input.sc-ion-searchbar-md {
  line-height: 27px;
  font-size: 13px;
}
.searchbar-input.sc-ion-searchbar-md {
  padding-left: unset;
  padding-right: unset;
  padding-inline-start: 15px;
  padding-inline-end: 40px;
  padding-top: 0;
  padding-bottom: 0;
}
@media only screen and (min-width: 1024px) {
  .searchbar-input.sc-ion-searchbar-md {
    line-height: 48px;
  }
  .searchbar-search-icon.sc-ion-searchbar-md {
    top: 50%;
    transform: translateY(-50%);
    color: var(--ion-color-grey);
  }
  .search-form {
    &__control {
      --box-shadow: inset 0 0 0 1px var(--ion-color-grey) !important;
    }
    .searchbar-has-focus {
      --box-shadow: inset 0 0 0 1px var(--ion-color-primary) !important;
    }
  }
}
</style>
